export default __webpack_public_path__ + "static/media/limenaqs4.9f7c23c0.jpg";